import styled, { css } from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

export const ViewWrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.unit * 2}px;
    box-sizing: border-box;

    ${media.sm`
            padding: 49.5px ${theme.spacing.unit * 5}px ${
      theme.spacing.unit * 5
    }px;
            width: 600px;
        `}
  `}
`;

export const Body = styled.div`
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: clamp(0.75rem, 2vw, 1rem);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column nowrap;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.unit * 3}px;
`;

export const AnimationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const StepWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  width: 100%;
  text-align: left;

  & > :first-child {
    padding-right: ${({ theme }) => theme.spacing.unit * 1.5}px;
  }
`;

export const Details = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  text-align: center;
`;
